<!--Main component for showing tweet search result-->
<template>

    <div class="container" v-if="tweetAddress" :key="tweetAddress">
        <h1>Results</h1>
        <transition name="fade">
            <div v-if="tweet" class="row">

                <!--Left column -->
                <div class="col-md-6 mb-4">

                    <tweet-veracity-display :tweet="tweet" :user="user" v-if="tweet"></tweet-veracity-display>

                    <tweet-replies></tweet-replies>

                </div>


                <!--{#################### Right column #####################}-->
                <div class="col-md-6 mb-4">
                    <tweet-user-profile :tweet-user="tweetUser"></tweet-user-profile>
                    <tweet-metadata :external-urls="tweet.external_urls" :media-entities="tweet.media_entities"
                                    :replies-external-urls="repliesExternalUrls"
                                    :replies-media-entities="repliesMediaEntities">
                    </tweet-metadata>
                </div>
            </div>
            <div v-else>
                <p class="font-weight-bold">
                    <span class="spinner-grow spinner-grow-sm mr-2" role="status" aria-hidden="true"></span>
                    Searching for tweet...
                </p>
            </div>
        </transition>

    </div>
</template>

<script>

    import TweetVeracityDisplay from "./TweetVeracityDisplay"
    import TweetReplies from "./TweetReplies";
    import TweetMetadata from "./TweetMetadata";
    import TweetUserProfile from "./TweetUserProfile";
    import {mapState, mapGetters, mapActions} from 'vuex'

    const axios = require('axios').default;
    let axios_cancel = null;

    export default {
        name: "TweetSearchResult.vue",
        props: ['tweetAddress'],
        data() {
            return {}
        },
        computed: {
            ...mapState(["tweet", "tweetUser", "user"]),
            ...mapGetters(["repliesExternalUrls", "repliesMediaEntities"]),
            tweetId: function () {
                if (this.tweet) {
                    return this.tweet.id_str;
                } else {
                    return null;
                }
            }
        },
        methods: {
            ...mapActions(["updateTweet"])
        },
        watch: {
            tweetAddress: {
                immediate: true,
                handler(address, oldAddress) {
                    if (address) {
                        this.updateTweet({address: address});
                    }
                }
            }
        },
        components: {
            TweetUserProfile,
            TweetMetadata,
            TweetReplies,
            TweetVeracityDisplay,
        },

    };

</script>

<style scoped>

</style>
